import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/atoms/button";
import Loading from "../../components/atoms/loading";
import Select from "../../components/atoms/select";
import NavBar from "../../components/organisms/navbar";
import rule from "../../data/rules-xxxi-copa-orley-lobato2.json";

import rulesSeletivaManausOlimpica2024 from "../../data/rules-seletiva-manaus-olimpica-2024.json";
import rulesViiiReiERainhaDaPraiaBeachWrestilingManausAmazonas2024 from "../../data/rules-viii-rei-e-rainha-da-praia-beach-wrestiling-manaus-amazonas-2024.json";
import rulescopaAmizadeDeJiuJitsu2024 from "../../data/rules-copa-amizade-de-jiu-jitsu-2024.json";
import rulesOpenGuaraniacuJiuJitsu2024 from "../../data/rules-open-guaraniacu-jiu-jitsu-2024.json";
import rulesIReiERainhaDaPraiaBeachBoxingManausAmazonas2023 from "../../data/rules-i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023.json";
import _1copaArenaParintinsDeJiuJitsu from "../../data/rules-1-copa-arena-parintins-de- jiu-jitsu.json";
import rulesGFTeam from "../../data/rules-estadual-gfteam-amazonas2.json";
import reiRainha from "../../data/rules-vii-rei-e-rainha-da-praia-beach-wrestling-manaus-amazonas.json";
import rulesToledoOpen2023 from "../../data/rules-toledo-international-open-brazilian-jiu-jitsu-gi-2023-ginasio-de-esportes-alcides-pan-toledo-pr.json";
import rulesCircuit from "../../data/rules-international-circuit2.json";
import useAuthenticate from "../../hooks/useAuthenticate";
import api from "../../services/api";
import { Content, FormContainer, PageDescription, PageTitle } from "./styles";
import SelectFighters from "../../components/atoms/selectFighters";
import SelectCategories from "src/components/atoms/selectCategories";
import loading from "../../components/atoms/loading";
import EnrollmentSeletivaManausOlimpica2024 from "./tournament/enrollment-seletiva-manaus-olimpica-2024";
import EnrollmentViiiReiERainhaDaPraiaBeachWrestiling2024 from "./tournament/enrollment-viii-rei-e-rainha-da-praia-beach-wrestiling-manaus-amazonas-2024";
import EnrollmentCopaAmizadeDeJiuJitsu2024 from "./tournament/enrollment-copa-amizade-de-jiu-jitsu-2024";
import EnrollmentCopaMestreAcaiDeJiuJitsu2024 from "./tournament/enrollment-copa-mestre-acai-de-jiu-jitsu-2024";
import EnrollmentXxxiiCopaOrleyLobatoDeJiuJitsu from "./tournament/enrollment-xxxii-orley-lobato-de-jiu-jitsu";
import EnrollmentIvOpenTerrSantaDeJiuJitsu from "./tournament/enrollment-iv-open-terra-santa-de-jiu-jitsu";
import EnrollmentXviiCopaParanaDeJiuJitsu from "./tournament/enrollment-xvii-copa-parana-de-jiu-jitsu";
import EnrollmentIOrixicombatOpenJiuJitsu from "./tournament/enrollment-i-orixicombat-open-jiu-jitsu";
import EnrollmentIiCopaArenaParintinsDejiujitsu from "./tournament/enrollment-ii-copa-arena-parintins-de-jiu-jitsu";
import EnrollmentCopaThomasiDeJiuJitsu from "./tournament/enrollment-copa-thomasi-de-jiu-jitsu";
import EnrollmentCopaLoboBravoCresolDeJiuJitsu from "./tournament/enrollment-copa-lobo-bravo-cresol-de-jiu-jitsu";
import EnrollmentCopaFronteiraDeJiuJitsu from "./tournament/enrollment-copa-fronteira-de-jiu-jitsu";
import EnrollmentViiOpenAmazonasTopTeamDeJiuJitsu from "./tournament/enrollment-vii-open-amazonas-top-team-de-jiu-jitsu";
import EnrollmentCopaCianorteDeJiuJitsu from "./tournament/enrollment-copa-cianorte-de-jiu-jitsu";
import EnrollmentViReiDaPraiaDeJiuJitsuNoGi from "./tournament/enrollment-vi-rei-da-praia-de-jiu-jitsu-no-gi";
import EnrollmentIiCopaChampionsKidsDeJiuJitsu from "./tournament/enrollment-ii-copa-champions-kids-de-jiu-jitsu";
import EnrollmentIiiOpenRochaEMoraesDeJiuJitsu from "./tournament/enrollment-iii-open-rocha-e-moraes-de-jiu-jitsu";
import EnrollmentIOpenLaranjeirasDoSulDeJiuJitsu from "./tournament/enrollment-i-open-laranjeiras-do-sul-de-jiu-jitsu";
import EnrollmentEstadualGfTeamAmazonasDeJiuJitsu from "./tournament/enrollment-estadual-gf-team-amazonas-jiu-jitsu";
import EnrollmentXxixCopaLuisNetoDeJiuJitsu from "./tournament/enrollment-xxix-copa-luis-neto-jiu-jitsu";
import EnrollmentEstadualGfTeamAmazonasDeJiuJitsuGiNoGiCombo from "./tournament/enrollment-estadual-gf-team-amazonas-jiu-jitsu-gi-nogi-combo";
import EnrollmentEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsuGiNoGiCombo from "./tournament/enrollment-etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-gi-nogi-combo";
import EnrollmentCampeonatoParintinenseDeJiuJitsuGiNoGiCombo from "./tournament/enrollment-campeonato-parintinense-jiu-jitsu-gi-nogi-combo";
import EnrollmentXviiiCopaParanaDeJiuJitsuGiNoGiCombo from "./tournament/enrollment-xviii-copa-parana-de-jiu-jitsu-gi-nogi-combo";
import EnrollmentCopaInTheGuardDeJiuJitsu from "./tournament/enrollment-copa-in-the-guard-de-jiu-jitsu";
import EnrollmentCopaAmizadeDeJiuJitsu2025 from "./tournament/enrollment-copa-amizade-de-jiu-jitsu-2025";
import EnrollmentViiCopaCampeoesDeJiuJitsu2025 from "./tournament/enrollment-vii-copa-campeoes-de-jiu-jitsu-2025";
import EnrollmentCopaTorneioFacilDeJiuJitsu from "./tournament/enrollment-copa-torneio-facil-de-jiu-jitsu";
import EnrollmentCopaMercosulDeJiuJitsu2025 from "./tournament/enrollment-copa-mercosul-de-jiu-jitsu-2025";
import EnrollmentCopaSantaTerezaDoOesteDeJiuJitsu2025 from "./tournament/enrollment-copa-santa-tereza-do-oeste-de-jiu-jitsu-2025";
import EnrollmentIiOpenNhamundaDeJiuJitsu2025 from "./tournament/enrollment-ii-open-nhamunda-de-jiu-jitsu-2025";
import EnrollmentVOpenTerraSantaDeJiuJitsu2025 from "./tournament/enrollment-v-open-terra-santa-de-jiu-jitsu-2025";
import EnrollmentIiiCopaBjjCascavelDeJiuJitsu2025 from "./tournament/enrollment-iii-copa-bjj-cascavel-de-jiu-jitsu-2025";
import EnrollmentUpdateIiiCopaBjjCascavelDeJiuJitsu2025 from "../enrollment-update/tournament/enrollment-update-iii-copa-bjj-cascavel-de-jiu-jitsu-2025";
import EnrollmentIiOpenNhamundaDeJiuJitsu2025Absoluto from "./tournament/enrollment-ii-open-nhamunda-de-jiu-jitsu-2025-absoluto";
import EnrollmentIiCopaThomasiDeJiuJitsu2025 from "./tournament/enrollment-ii-copa-thomasi-de-jiu-jitsu-2025";
import EnrollmentOpenCandoiDeJiuJitsu2025 from "./tournament/enrollment-open-candoi-de-jiu-jitsu-2025";
import EnrollmentCopaMestreDoAcaiDeJiuJitsu2025 from "./tournament/enrollment-copa-mestre-do-acai-de-jiu-jitsu-2025";
import EnrollmentCopaFronteiraDeJiuJitsu2025 from "./tournament/enrollment-copa-fronteira-de-jiu-jitsu-2025";
import EnrollmentOpenCascavelInternationalDeJiuJitsu2025 from "./tournament/enrollment-open-cascavel-international-de-jiu-jitsu-2025";
import EnrollmentIiCopaAquilesDeJiuJitsu2025 from "./tournament/enrollment-ii-copa-aquiles-de-jiu-jitsu-2025";
import EnrollmentIValenteKidsDeJiuJitsu2025 from "./tournament/enrollment-i-valente-kids-de-jiu-jitsu-2025";
import EnrollmentICopaLeaoDeJudaDeJiuJitsu2025 from "./tournament/enrollment-i-copa-leao-de-juda-de-jiu-jitsu-2025";
import EnrollmentCopaLoboBravoCresolDeJiuJitsu2025 from "./tournament/enrollment-copa-lobo-bravo-cresol-de-jiu-jitsu-2025";
import EnrollmentXxxiiiCopaOrleyLobatoDeJiuJitsu2025 from "./tournament/enrollment-xxxiii-copa-orley-lobato-de-jiu-jitsu-2025";
import EnrollmentOpenFiveDeJiuJitsu2025 from "./tournament/enrollment-open-five-de-jiu-jitsu-2025";
import EnrollmentViiiOpenAmazonasTopTeamDeJiuJitsu2025 from "./tournament/enrollment-viii-open-amazonas-top-team-de-jiu-jitsu-2025";
import EnrollmentIxReiERainhaDaPraiaBeachWrestling2025 from "./tournament/enrollment-ix-rei-e-rainha-da-praia-beach-wrestiling-2025";
import EnrollmentCopaCianorteDeJiuJitsu2025 from "./tournament/enrollment-copa-cianorte-de-jiu-jitsu-2025";
import EnrollmentViiiLijjamCombatDeJiuJitsu2025 from "./tournament/enrollment-viii-lijjam-combat-de-jiu-jitsu-2025";
import EnrollmentLijjamCombatIxCombatDeJiuJitsu2026 from "./tournament/enrollment-lijjam-combat-ix-de-jiu-jitsu-2026";
import EnrollmentEstadualGfTeamAmazonasDeJiuJitsu2025 from "./tournament/enrollment-estadual-gfteam-amazonas-de-jiu-jitsu-2025";
import EnrollmentICopaEuAmoParintinsDeJiuJitsu2025 from "./tournament/enrollment-i-copa-eu-amo-parintins-de-jiu-jitsu-2025";
import EnrollmentOpenChallengerDeJiuJitsu2025 from "./tournament/enrollment-open-challenger-de-jiu-jitsu-2025";
import EnrollmentFozOpenConfrontoInternacionalDeJiuJitsu2025 from "./tournament/enrollment-foz-open-confronto-internacional-de-jiu-jitsu-2025";
import EnrollmentViiReiDaPraiaDeJiuJitsu2025 from "./tournament/enrollment-vii-rei-da-praia-de-jiu-jitsu-no-gi-2025";
import EnrollmentCopaMestreDoAcaiKidsDeJiuJitsu2025 from "./tournament/enrollment-copa-mestre-do-acai-kids-de-jiu-jitsu-2025";
import EnrollmentOpenParanavaiBrasilianDeJiuJitsu2025 from "./tournament/enrollment-open-paranavai-brazilian-de-jiu-jitsu-2025";
import EnrollmentNoroesteOpenDeJiuJitsu2025 from "./tournament/enrollment-noroeste-open-de-jiu-jitsu-2025";
import EnrollmentIvOpenParaguacuPaulistaDeJiuJitsu2025 from "./tournament/enrollment-iv-open-paraguacu-paulista-de-jiu-jitsu-2025";
import EnrollmentIiiCopaChampionsKidsEICopaBushidoAdultoDeJiuJitsu2025 from "./tournament/enrollment-iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025";
import EnrollmentOpenLaranjeirasDoSulDeJiuJitsu2025 from "./tournament/enrollment-open-laranjeiras-do-sul-de-jiu-jitsu-2025";
import EnrollmentToledoOpenBrazilianDeJiuJitsu2025 from "./tournament/enrollment-toledo-open-brazilian-de-jiu-jitsu-2025";
import EnrollmentCopaTomeyaSasaharaDeJiuJitsu2025 from "./tournament/enrollment-copa-tomeya-sasahara-de-jiu-jitsu-2025";
import EnrollmentICopaFaixaSolidariaDeJiuJitsu2025 from "./tournament/enrollment-i-copa-faixa-solidaria-de-jiu-jitsu-2025";
import EnrollmentCopaOpenExtremeManausDeJiuJitsu2025 from "./tournament/enrollment-copa-open-extreme-manaus-de-jiu-jitsu-2025";
import EnrollmentXiCopaLondrinaDeJiuJitsu2025 from "./tournament/enrollment-xi-copa-londrina-de-jiu-jitsu-2025";
import EnrollmentCopaArapongasDeJiuJitsu2026 from "./tournament/enrollment-copa-arapongas-de-jiu-jitsu-2026";
import EnrollmentXixCopaParanaDeJiuJitsu2026 from "./tournament/enrollment-xix-copa-parana-de-jiu-jitsu-2026";
import EnrollmentCircuitoInternacionalDeJiuJitsu2026 from "./tournament/enrollment-circuito-internacional-de-jiu-jitsu-2026";
import EnrollmentCopaParintinenseDeJiuJitsu2026 from "./tournament/enrollment-copa-parintinense-de-jiu-jitsu-2026";
import EnrollmentIiCopaMercosulDeJiuJitsu2026 from "./tournament/enrollment-ii-copa-mercosul-de-jiu-jitsu-2026";
import EnrollmentStiOpenKidsDeJiuJitsu2026 from "./tournament/enrollment-sti-open-kids-de-jiu-jitsu-2026";
import EnrollmentCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 from "./tournament/enrollment-campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026";
import EnrollmentIGrandSlamEstadualDeJiuJitsuFeminino2026 from "./tournament/enrollment-i-grand-slam-estadual-de-jiu-jitsu-feminino-2026";
import EnrollmentViiiCopaCampeoesDeJiuJitsu2026 from "./tournament/enrollment-viii-copa-campeoes-de-jiu-jitsu-2026";
import EnrollmentSeletivaManausOlimpicaDeJiuJitsu2026 from "./tournament/enrollment-seletiva-manaus-olimpica-de-jiu-jitsu-2026-gi";
import EnrollmentCopaAmizadeDeJiuJitsu2026 from "./tournament/enrollment-copa-amizade-de-jiu-jitsu-2026";
import EnrollmentIvCopaClbjjDeJiuJitsu2026 from "./tournament/enrollment-iv-copa-clbjj-de-jiu-jitsu-2026";
import EnrollmentICopaBjjTalentDeJiuJitsu2026 from "./tournament/enrollment-i-copa-bjj-talent-de-jiu-jitsu-2026";
import EnrollmentOpenFiveDeJiuJitsu2026 from "./tournament/enrollment-open-five-de-jiu-jitsu-2026";
import EnrollmentCircuitoFajjeCoariDeJiuJitsuCoariAm from "./tournament/enrollment-circuito-fajje-coari-de-jiu-jitsu-coari-am";
import EnrollmentICircuitoAmazonenseFajjoManausAm from "./tournament/enrollment-i-circuito-amazonense-fajjo-manaus-am";
import EnrollmentOpenCambeDeJiuJitsu2026 from "./tournament/enrollment-open-cambe-de-jiu-jitsu-2026";
import EnrollmentICampeonatoAmazonenseDeMmaAmador2026 from "./tournament/enrollment-i-campeonato-amazonense-de-mma-amador-2026";
import EnrollmentDesafioZonaNorteDeJiuJitsuManausAm2026 from "./tournament/enrollment-desafio-zona-norte-de-jiu-jitsu-manaus-am-2026";
import EnrollmentIiCopaBushidoDeJiuJitsu2026 from "./tournament/enrollment-ii-copa-bushido-de-jiu-jitsu-2026";
import EnrollmentViOpenTerraSantaDeJiuJitsu2026 from "./tournament/enrollment-vi-open-terra-santa-de-jiu-jitsu-2026";
import EnrollmentICampeonatoInternoCtTeamKombatDeJiuJitsu2026 from "./tournament/enrollment-i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026";
import EnrollmentXxxivCopaOrleyLobatoDeJiuJitsu2026 from "./tournament/enrollment-xxxiv-copa-orley-lobato-de-jiu-jitsu-2026";
import EnrollmentIiOpenChallengerDeJiuJitsu2026 from "./tournament/enrollment-ii-open-challenger-de-jiu-jitsu-2026";



const Enrollment = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Adiciona cache buster se não estiver presente
    if (!window.location.search.includes("cacheBuster")) {
      const cacheBuster = `cacheBuster=${new Date().getTime()}`;
      const newUrl = `${window.location.pathname}?${cacheBuster}`;
      navigate(newUrl, { replace: true }); // Redireciona para a nova URL
    }
  }, []);

  switch (slug) {
    case "copa-torneio-facil-de-jiu-jitsu-manaus-am-gi":
       return <EnrollmentCopaTorneioFacilDeJiuJitsu />;
    case "seletiva-manaus-olimpica-2024-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <EnrollmentSeletivaManausOlimpica2024 />;
    case "viii-rei-e-rainha-da-praia-beach-wrestling-2024-nossa-praia-sports":
    case "i-rei-e-rainha-da-praia-beach-boxing-manaus-amazonas-2023-manaus-amazonas":
      return <EnrollmentViiiReiERainhaDaPraiaBeachWrestiling2024 />;
    case "copa-amizade-de-jiu-jitsu-2024-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
      return <EnrollmentCopaAmizadeDeJiuJitsu2024 />;
    case "copa-mestre-acai-de-jiu-jitsu-2024-ginasio-arrudao-francisco-beltao-pr":
      return <EnrollmentCopaMestreAcaiDeJiuJitsu2024 />;
    case "xxxii-copa-orley-lobato-de-jiu-jitsu-cel-nininberg-guerra-manaus-am":
      return <EnrollmentXxxiiCopaOrleyLobatoDeJiuJitsu />;
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-gi":
    case "iv-opem-terra-santa-de-jiu-jistu-ginasio-braulio-nelson-da-conceicao-nogi":
      return <EnrollmentIvOpenTerrSantaDeJiuJitsu />;
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-nogi":
    case "xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-gi":
      return <EnrollmentXviiCopaParanaDeJiuJitsu />;
    case "i-orixicombat-open-jiu-jitsu-ginasio-municipal-de-oriximina-pa":
      return <EnrollmentIOrixicombatOpenJiuJitsu />;
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
      return <EnrollmentIiCopaArenaParintinsDejiujitsu />;
    case "i-copa-thomasi-de-jiu-jitsu-parque-do-japao-maringa-pr":
      return <EnrollmentCopaThomasiDeJiuJitsu />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-ginasio-assuncao-de-nossa-senhora-guarapuava-pr":
      return <EnrollmentCopaLoboBravoCresolDeJiuJitsu />;
    case "copa-fronteira-de-jiu-jitsu-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr":
      return <EnrollmentCopaFronteiraDeJiuJitsu />;
    case "vii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
      return <EnrollmentViiOpenAmazonasTopTeamDeJiuJitsu />;
    case "copa-cianorte-de-jiu-jitsu-cianorte-pr-gi":
      return <EnrollmentCopaCianorteDeJiuJitsu />;
    case "vi-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
      return <EnrollmentViReiDaPraiaDeJiuJitsuNoGi />;
    case "ii-copa-champions-kids-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentIiCopaChampionsKidsDeJiuJitsu />;
    case "iii-open-rocha-e-moraes-de-jiu-jitsu-manaus-am-gi":
      return <EnrollmentIiiOpenRochaEMoraesDeJiuJitsu />;
    case "i-open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-pr-gi":
      return <EnrollmentIOpenLaranjeirasDoSulDeJiuJitsu />;
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-gi":
    case "estadual-gf-team-amazonas-jiu-jitsu-manaus-am-nogi":
      //return <EnrollmentEstadualGfTeamAmazonasDeJiuJitsu />;
      return <EnrollmentEstadualGfTeamAmazonasDeJiuJitsuGiNoGiCombo />;
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-gi":
    case "xxix-copa-luis-neto-jiu-jitsu-manaus-am-nogi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-gi":
    case "copa-manacapuru-de-jiu-jitsu-mananacapuru-am-nogi":
      return <EnrollmentXxixCopaLuisNetoDeJiuJitsu />;
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-gi":
    case "etapa-oriximina-xxxii-copa-orley-lobato-jiu-jitsu-oriximina-pa-nogi":
      return <EnrollmentEtapaOriximinaXxxiiCopaOrleyLobatoDeJiuJitsuGiNoGiCombo />;
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi":
    case "campeonato-parintinense-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi":
      return <EnrollmentCampeonatoParintinenseDeJiuJitsuGiNoGiCombo />;
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xviii-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <EnrollmentXviiiCopaParanaDeJiuJitsuGiNoGiCombo />;
    case "copa-in-the-guard-de-jiu-jitsu-cascavel-pr-gi":
      return <EnrollmentCopaInTheGuardDeJiuJitsu />;
    case "copa-amizade-de-jiu-jitsu-2025-umuarama-pr-gi":
      return <EnrollmentCopaAmizadeDeJiuJitsu2025 />;
    case "vii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentViiCopaCampeoesDeJiuJitsu2025 />;
    case "copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <EnrollmentCopaMercosulDeJiuJitsu2025 />;
    case "copa-santa-tereza-do-oeste-de-jiu-jitsu-santa-tereza-do-oeste-pr-gi":
      return <EnrollmentCopaSantaTerezaDoOesteDeJiuJitsu2025 />;
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi":
      return <EnrollmentIiOpenNhamundaDeJiuJitsu2025 />;
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-gi-absoluto":
    case "ii-open-nhamunda-de-jiu-jitsu-nhamunda-am-nogi-absoluto":
      return <EnrollmentIiOpenNhamundaDeJiuJitsu2025Absoluto />;
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-gi":
    case "v-open-terra-santa-de-jiu-jitsu-2025-terra-santa-pa-nogi":
      return <EnrollmentVOpenTerraSantaDeJiuJitsu2025 />;
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-gi":
    case "iii-copa-bjj-cascavel-de-jiu-jitsu-cascavel-pr-nogi":
      return <EnrollmentIiiCopaBjjCascavelDeJiuJitsu2025 />;
    case "ii-copa-thomasi-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentIiCopaThomasiDeJiuJitsu2025 />;
    case "open-candoi-de-jiu-jitsu-candoi-centro-sul-pr-gi":
      return <EnrollmentOpenCandoiDeJiuJitsu2025 />;
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-gi":
    case "copa-mestre-do-acai-de-jiu-jitsu-francisco-beltrao-pr-nogi":
      return <EnrollmentCopaMestreDoAcaiDeJiuJitsu2025 />;
    case "copa-fronteira-de-jiu-jitsu-2025-umuarama-pr-gi":
      return <EnrollmentCopaFronteiraDeJiuJitsu2025 />;
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-gi":
    case "open-cascavel-international-de-jiu-jitsu-cascavel-pr-nogi":
      return <EnrollmentOpenCascavelInternationalDeJiuJitsu2025 />;
    case "ii-copa-aquiles-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <EnrollmentIiCopaAquilesDeJiuJitsu2025 />;
    case "i-valente-kids-de-jiu-jitsu-nova-olimpia-pr-gi":
      return <EnrollmentIValenteKidsDeJiuJitsu2025 />;
    case "i-copa-leao-de-juda-de-jiu-jitsu-mandaguari-pr-gi":
      return <EnrollmentICopaLeaoDeJudaDeJiuJitsu2025 />;
    case "copa-lobo-bravo-cresol-de-jiu-jitsu-guarapuava-pr-gi":
      return <EnrollmentCopaLoboBravoCresolDeJiuJitsu2025 />;
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
    case "xxxiii-copa-orley-lobato-de-jiu-jitsu-manaus-am-absoluto":
      return <EnrollmentXxxiiiCopaOrleyLobatoDeJiuJitsu2025 />;
    case "open-five-de-jiu-jitsu-londrina-pr-gi":
    case "open-five-de-jiu-jitsu-londrina-pr-nogi":
      return <EnrollmentOpenFiveDeJiuJitsu2025 />;
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-gi":
    case "viii-open-amazonas-top-team-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentViiiOpenAmazonasTopTeamDeJiuJitsu2025 />;
    case "ix-rei-e-rainha-da-praia-beach-wrestiling-2025-manaus-am":
      return <EnrollmentIxReiERainhaDaPraiaBeachWrestling2025 />;
    case "copa-cianorte-de-jiu-jitsu-2025-cianorte-pr-gi":
      return <EnrollmentCopaCianorteDeJiuJitsu2025 />;
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-gi":
    case "viii-lijjam-combat-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentViiiLijjamCombatDeJiuJitsu2025 />;
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-gi":
    case "lijjam-combat-ix-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentLijjamCombatIxCombatDeJiuJitsu2026 />;
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-gi":
    case "estadual-gfteam-amazonas-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentEstadualGfTeamAmazonasDeJiuJitsu2025 />;
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-gi":
    case "i-copa-eu-amo-parintins-de-jiu-jitsu-parintins-am-absoluto":
      return <EnrollmentICopaEuAmoParintinsDeJiuJitsu2025 />;
    case "foz-open-confronto-internacional-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <EnrollmentFozOpenConfrontoInternacionalDeJiuJitsu2025 />;
    case "open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "open-challenger-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentOpenChallengerDeJiuJitsu2025 />;
    case "vii-rei-da-praia-de-jiu-jitsu-santarem-pa-nogi":
      return <EnrollmentViiReiDaPraiaDeJiuJitsu2025 />;
    case "copa-mestre-do-acai-de-kids-jiu-jitsu-francisco-beltrao-pr-gi":
      return <EnrollmentCopaMestreDoAcaiKidsDeJiuJitsu2025 />;
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-gi":
    case "open-paranavai-brazilian-de-jiu-jitsu-paranavai-pr-nogi":
      return <EnrollmentOpenParanavaiBrasilianDeJiuJitsu2025 />;
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi":
    case "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi":
      return <EnrollmentNoroesteOpenDeJiuJitsu2025 />;
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi":
    case "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi":
      return <EnrollmentIvOpenParaguacuPaulistaDeJiuJitsu2025 />;
    case "iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentIiiCopaChampionsKidsEICopaBushidoAdultoDeJiuJitsu2025 />;
    case "open-laranjeiras-do-sul-de-jiu-jitsu-laranjeiras-do-sul-pr-gi":
      return <EnrollmentOpenLaranjeirasDoSulDeJiuJitsu2025 />;
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-gi":
    case "toledo-open-brazilian-de-jiu-jitsu-toledo-pr-nogi":
      return <EnrollmentToledoOpenBrazilianDeJiuJitsu2025 />;
    case "copa-tomeya-sasahara-de-jiu-jitsu-umuarama-pr-gi":
      return <EnrollmentCopaTomeyaSasaharaDeJiuJitsu2025 />;
    case "i-copa-faixa-solidaria-de-jiu-jitsu-manaus-am-gi":
      return <EnrollmentICopaFaixaSolidariaDeJiuJitsu2025 />;
    case "copa-open-extreme-manaus-de-jiu-jitsu-manaus-am-gi":
      return <EnrollmentCopaOpenExtremeManausDeJiuJitsu2025 />;
    case "xi-copa-londrina-de-jiu-jitsu-londrina-pr-gi":
      return <EnrollmentXiCopaLondrinaDeJiuJitsu2025 />;
    case "copa-arapongas-de-jiu-jitsu-arapongas-pr-gi":
      return <EnrollmentCopaArapongasDeJiuJitsu2026 />;
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-gi":
    case "xix-copa-parana-de-jiu-jitsu-cascavel-pr-nogi":
      return <EnrollmentXixCopaParanaDeJiuJitsu2026 />;
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-gi":
    case "circuito-internacional-de-jiu-jitsu-cascavel-pr-nogi":
      return <EnrollmentCircuitoInternacionalDeJiuJitsu2026 />;
    case "copa-parintinense-de-jiu-jitsu-parintins-am-gi":
    case "copa-parintinense-de-jiu-jitsu-parintins-am-nogi":
      return <EnrollmentCopaParintinenseDeJiuJitsu2026 />;
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-gi":
    case "ii-copa-mercosul-de-jiu-jitsu-foz-do-iguacu-pr-nogi":
      return <EnrollmentIiCopaMercosulDeJiuJitsu2026 />;
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-gi":
    case "sti-open-kids-de-jiu-jitsu-santa-terezinha-de-itaipu-pr-nogi":
      return <EnrollmentStiOpenKidsDeJiuJitsu2026 />;
    case "campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-manaus-am-gi":
      return <EnrollmentCampeonatoDeJiuJitsuGladiadoresAbleBjjJudo2026 />;
    case "i-grand-slam-estadual-de-jiu-jitsu-santarem-pa-gi":
      return <EnrollmentIGrandSlamEstadualDeJiuJitsuFeminino2026 />;
    case "viii-copa-campeoes-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentViiiCopaCampeoesDeJiuJitsu2026 />;
    case "seletiva-manaus-olimpica-2026-ginasio-ninimberg-guerra-sao-jorge-manaus-am":
      return <EnrollmentSeletivaManausOlimpicaDeJiuJitsu2026 />;
    case "copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi":
      return <EnrollmentCopaAmizadeDeJiuJitsu2026 />;
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-gi":
    case "iv-copa-clbjj-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentIvCopaClbjjDeJiuJitsu2026 />;
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-gi":
    case "i-copa-bjj-talent-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentICopaBjjTalentDeJiuJitsu2026 />;
    case "open-five-de-jiu-jitsu-curiuva-pr-gi":
      return <EnrollmentOpenFiveDeJiuJitsu2026 />;
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-gi":
    case "circuito-fajje-coari-de-jiu-jitsu-coari-am-nogi":
      return <EnrollmentCircuitoFajjeCoariDeJiuJitsuCoariAm />;
    case "i-circuito-amazonense-fajjo-manaus-am-gi":
    case "i-circuito-amazonense-fajjo-manaus-am-nogi":
      return <EnrollmentICircuitoAmazonenseFajjoManausAm />;
    case "open-cambe-de-jiu-jitsu-cambe-pr-gi":
      return <EnrollmentOpenCambeDeJiuJitsu2026 />;
    case "i-campeonato-amazonense-de-mma-amador-manaus-am":
      return <EnrollmentICampeonatoAmazonenseDeMmaAmador2026 />;
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-gi":
    case "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-nogi":
      return <EnrollmentDesafioZonaNorteDeJiuJitsuManausAm2026 />;
    case "ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi":
      return <EnrollmentIiCopaBushidoDeJiuJitsu2026 />;
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-gi":
    case "vi-open-terra-santa-de-jiu-jitsu-terra-santa-pa-nogi":
      return <EnrollmentViOpenTerraSantaDeJiuJitsu2026 />;
    case "i-campeonato-interno-ct-kombat-de-jiu-jitsu-foz-do-iguacu-pr-gi":
      return <EnrollmentICampeonatoInternoCtTeamKombatDeJiuJitsu2026 />;
    case "xxxiv-copa-orley-lobato-de-jiu-jitsu-manaus-am-gi":
      return <EnrollmentXxxivCopaOrleyLobatoDeJiuJitsu2026 />;
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-gi":
    case "ii-open-challenger-de-jiu-jitsu-manaus-am-nogi":
      return <EnrollmentIiOpenChallengerDeJiuJitsu2026 />;

    default:
      return <h1>Inscrição para esse Torneio não encontrado!</h1>;
  }
};

export default Enrollment;